import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import ReactHtmlParser from "react-html-parser";

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 600,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const Email = ({ body, url }) => {
  // eslint-disable-line
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const content = (
    <div style={modalStyle} className={classes.paper}>
      <a href={url} rel="noreferrer noopener" target="_blank">
        Preview In Mandrill UI
      </a>
      {ReactHtmlParser(body)}
    </div>
  );

  return (
    <div>
      <button type="button" onClick={handleOpen}>
        Preview
      </button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {content}
      </Modal>
    </div>
  );
};

Email.propTypes = {
  body: PropTypes.any,
  url: PropTypes.string,
};

export default Email;
